import { secondsToMilliseconds } from 'date-fns';

const JOIN_BUTTON_PULSE_DELAY_SECONDS = 5;
export const JOIN_BUTTON_PULSE_DELAY_MS = secondsToMilliseconds(JOIN_BUTTON_PULSE_DELAY_SECONDS);
